import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Spinner, Table } from 'react-bootstrap';
import { api } from "../../../services/api";
import Swal from "sweetalert2";
import { FaEdit, FaPlus, FaArrowLeft, FaCalendarCheck } from "react-icons/fa";

export default function ModalConcTaxa({ show, onHide }) {
    const [loading, setLoading] = useState(false);
    const [loadingEdicao, setLoadingEdicao] = useState(false);
    const [loadingAplicar, setLoadingAplicar] = useState(false);
    const [view, setView] = useState('lista');
    const [taxasCadastradas, setTaxasCadastradas] = useState([]);
    const [lookups, setLookups] = useState({ roteamentos: [], bandeiras: [], condicoes: [] });

    const [datasPeriodo, setDatasPeriodo] = useState({
        dtini: new Date().toISOString().split('T')[0],
        dtfim: new Date().toISOString().split('T')[0]
    });

    const converterDataParaAPI = (data) => {
        if (!data) return data;
        const [ano, mes, dia] = data.split('-');
        return `${dia}/${mes}/${ano}`;
    };

    const [form, setForm] = useState({
        roteamento: '',
        bandeira: '',
        condicao: '',
        taxa: 0,
        codicadastro: ''
    });

    useEffect(() => {
        if (show) {
            listarTaxas();
            carregarRoteamentos();
            setView('lista');
        }
    }, [show]);

    const carregarRoteamentos = () => {
        api.get('/financeiro/conciliacao/roteamentos')
            .then(res => setLookups(prev => ({ ...prev, roteamentos: res.data })))
            .catch(err => console.error("Erro ao carregar roteamentos", err));
    };

    const listarTaxas = async () => {
        setLoading(true);
        try {
            const res = await api.get('/financeiro/conciliacao/config-taxas');
            setTaxasCadastradas(res.data || []);
        } catch (err) {
            console.error("Erro ao listar taxas", err);
        } finally {
            setLoading(false);
        }
    };

    const handleAplicarNoPeriodo = async () => {
        const confirm = await Swal.fire({
            title: 'Confirmação',
            text: `Deseja aplicar as taxas atuais no período?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Cancelar'
        });

        if (!confirm.isConfirmed) return;

        setLoadingAplicar(true);
        try {
            const payload = {
                dtini: converterDataParaAPI(datasPeriodo.dtini),
                dtfim: converterDataParaAPI(datasPeriodo.dtfim)
            };
            await api.post('/financeiro/conciliacao/aplicar-taxas', payload);
            Swal.fire("Sucesso", "Taxas aplicadas!", "success");
        } catch (err) {
            Swal.fire("Erro", "Erro ao aplicar taxas", "error");
        } finally {
            setLoadingAplicar(false);
        }
    };

    const handleRoteamentoChange = async (val) => {
        setForm({ ...form, roteamento: val, bandeira: '', condicao: '' });
        if (!val) return;
        try {
            const res = await api.get(`/financeiro/conciliacao/bandeiras?roteamento=${val}`);
            setLookups(prev => ({ ...prev, bandeiras: res.data, condicoes: [] }));
        } catch (err) { console.error(err); }
    };

    const handleBandeiraChange = async (val) => {
        setForm({ ...form, bandeira: val, condicao: '' });
        if (!val) return;
        try {
            const res = await api.get(`/financeiro/conciliacao/condicoes?roteamento=${form.roteamento}&bandeira=${val}`);
            setLookups(prev => ({ ...prev, condicoes: res.data }));
        } catch (err) { console.error(err); }
    };

    const handleEditar = async (item) => {
        setLoadingEdicao(true);
        setView('formulario');
        try {
            const roteamento = item.ROTEAMENTO || item.roteamento;
            const bandeira = item.BANDEIRA || item.bandeira;
            const resB = await api.get(`/financeiro/conciliacao/bandeiras?roteamento=${roteamento}`);
            const resC = await api.get(`/financeiro/conciliacao/condicoes?roteamento=${roteamento}&bandeira=${bandeira}`);
            setLookups(prev => ({ ...prev, bandeiras: resB.data, condicoes: resC.data }));
            setForm({
                roteamento: roteamento,
                bandeira: bandeira,
                condicao: item.CONDICAO || item.condicao,
                taxa: item.TAXA || item.taxa,
                codicadastro: item.CODICADASTRO || item.codicadastro
            });
        } catch (err) {
            Swal.fire("Erro", "Falha ao carregar dados", "error");
        } finally {
            setLoadingEdicao(false);
        }
    };

    const handleSalvar = async () => {
        setLoading(true);
        try {
            await api.post('/financeiro/conciliacao/taxa', form);
            Swal.fire("Sucesso", "Configuração salva!", "success");
            listarTaxas();
            setView('lista');
        } catch (err) {
            Swal.fire("Erro", "Erro ao salvar", "error");
        } finally {
            setLoading(false);
        }
    };

    const renderDataList = (id, lista, campo) => (
        <datalist id={id}>
            {lista.map((item, index) => (
                <option key={index} value={typeof item === 'object' ? item[campo] : item} />
            ))}
        </datalist>
    );

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="lg"
            backdrop="static"
            scrollable={true} // CORREÇÃO 1: Ativa o scroll interno do modal
        >
            <Modal.Header closeButton className="bg-dark text-white p-2">
                <Modal.Title className="small fw-bold ms-2">
                    {view === 'lista' ? 'CONFIGURAÇÃO DE TAXAS' : 'EDITAR TAXA'}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="bg-light" style={{ overflowX: 'hidden' }}>
                {/* CORREÇÃO 2: overflowX hidden evita barras horizontais chatas */}
                {view === 'lista' ? (
                    <>
                        <div className="card p-3 mb-3 border-warning shadow-sm">
                            <h6 className="fw-bold small text-warning mb-2"><FaCalendarCheck className="me-2" />APLICAR TAXAS AO PERÍODO</h6>
                            <Row className="g-2 align-items-end">
                                <Col md={4}>
                                    <Form.Label className="small fw-bold m-0">Início</Form.Label>
                                    <Form.Control size="sm" type="date" value={datasPeriodo.dtini} onChange={e => setDatasPeriodo({ ...datasPeriodo, dtini: e.target.value })} />
                                </Col>
                                <Col md={4}>
                                    <Form.Label className="small fw-bold m-0">Fim</Form.Label>
                                    <Form.Control size="sm" type="date" value={datasPeriodo.dtfim} onChange={e => setDatasPeriodo({ ...datasPeriodo, dtfim: e.target.value })} />
                                </Col>
                                <Col md={4}>
                                    <Button variant="warning" size="sm" className="w-100 fw-bold" onClick={handleAplicarNoPeriodo} disabled={loadingAplicar}>
                                        {loadingAplicar ? <Spinner size="sm" /> : 'APLICAR NO BANCO'}
                                    </Button>
                                </Col>
                            </Row>
                        </div>

                        <div className="d-flex justify-content-between mb-2 align-items-center">
                            <h6 className="fw-bold m-0 small">Taxas Ativas</h6>
                            <Button variant="success" size="sm" onClick={() => {
                                setForm({ roteamento: '', bandeira: '', condicao: '', taxa: 0, codicadastro: '' });
                                setView('formulario');
                            }}>
                                <FaPlus className="me-2" /> NOVA TAXA
                            </Button>
                        </div>

                        {/* CORREÇÃO 3: Wrapper de tabela com altura máxima e scroll próprio */}
                        <div className="table-responsive bg-white shadow-sm border rounded" style={{ maxHeight: '450px', overflowY: 'auto' }}>
                            <Table striped bordered hover size="sm" className="mb-0">
                                <thead className="table-secondary small text-center sticky-top">
                                    <tr>
                                        <th>Roteamento</th>
                                        <th>Bandeira</th>
                                        <th>Condição</th>
                                        <th>Taxa</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody className="small text-center">
                                    {loading ? (
                                        <tr><td colSpan="5" className="p-3"><Spinner animation="border" size="sm" /></td></tr>
                                    ) : taxasCadastradas.map((t, i) => (
                                        <tr key={i}>
                                            <td>{t.ROTEAMENTO || t.roteamento}</td>
                                            <td>{t.BANDEIRA || t.bandeira}</td>
                                            <td>{t.CONDICAO || t.condicao}</td>
                                            <td className="fw-bold text-danger">{Number(t.TAXA || t.taxa).toFixed(2)}%</td>
                                            <td>
                                                <Button variant="outline-primary" size="sm" onClick={() => handleEditar(t)}>
                                                    <FaEdit />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </>
                ) : (
                    <Form>
                        <Button variant="link" size="sm" onClick={() => setView('lista')} className="mb-3 p-0 text-decoration-none fw-bold text-primary">
                            <FaArrowLeft className="me-2" /> VOLTAR PARA LISTA
                        </Button>

                        {loadingEdicao ? (
                            <div className="text-center p-5"><Spinner animation="border" /></div>
                        ) : (
                            <Row className="g-3">
                                <Col md={12}>
                                    <label className="small fw-bold">Roteamento</label>
                                    <Form.Control
                                        size="sm"
                                        list="list-roteamentos"
                                        value={form.roteamento}
                                        onChange={e => handleRoteamentoChange(e.target.value)}
                                        placeholder="Selecione..."
                                    />
                                    {renderDataList("list-roteamentos", lookups.roteamentos, 'ROTEAMENTO')}
                                </Col>

                                <Col md={12}>
                                    <label className="small fw-bold">Bandeira</label>
                                    <Form.Control
                                        size="sm"
                                        list="list-bandeiras"
                                        value={form.bandeira}
                                        onChange={e => handleBandeiraChange(e.target.value)}
                                        placeholder="Selecione..."
                                    />
                                    {renderDataList("list-bandeiras", lookups.bandeiras, 'BANDEIRA')}
                                </Col>

                                <Col md={12}>
                                    <label className="small fw-bold">Condição</label>
                                    <Form.Control
                                        size="sm"
                                        list="list-condicoes"
                                        value={form.condicao}
                                        onChange={e => setForm({ ...form, condicao: e.target.value })}
                                        placeholder="Selecione..."
                                    />
                                    {renderDataList("list-condicoes", lookups.condicoes, 'CONDICAO')}
                                </Col>

                                <Col md={6}>
                                    <label className="small fw-bold">Taxa (%)</label>
                                    <Form.Control size="sm" type="number" step="0.01" value={form.taxa} onChange={e => setForm({ ...form, taxa: e.target.value })} />
                                </Col>
                                <Col md={6}>
                                    <label className="small fw-bold">Cód. Cadastro</label>
                                    <Form.Control size="sm" type="text" value={form.codicadastro} onChange={e => setForm({ ...form, codicadastro: e.target.value })} />
                                </Col>
                            </Row>
                        )}
                    </Form>
                )}
            </Modal.Body>

            <Modal.Footer className="p-2">
                <Button variant="secondary" size="sm" onClick={onHide}>FECHAR</Button>
                {view === 'formulario' && !loadingEdicao && (
                    <Button variant="primary" size="sm" onClick={handleSalvar} disabled={loading}>
                        {loading ? 'GRAVAR...' : 'GRAVAR TAXA'}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}